import * as React from "react";
import type { SVGProps } from "react";
const SvgLoader01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 6.3V1.5m0 21v-4.8m5.7-5.7h4.8m-21 0h4.8m9.73-4.03 3.395-3.394M4.575 19.425l3.394-3.394m8.062 0 3.394 3.393M4.575 4.575 7.969 7.97"
    />
  </svg>
);
export default SvgLoader01;
